// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import OrderDetail from './OrderDetail';

import { IRoute } from '../';

const Routes: IRoute[] = [
    {
        crumbText: 'order_detail',
        component: OrderDetail,
        exact: true,
        path: '/device/orderDetail',
    },
];

export default Routes;